import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import benefitsBg from '../../../../../assets/images/reg-guide/benefits-bg.png';

export const useStyles = makeStyles(({
  fontSizes, fontWeights, palette, lineHeights, breakpoints,
}: Theme) => ({
  root: {
    width: '100%',
    background: `linear-gradient(180deg, ${palette.primary.dark} 0%, ${palette.primary.main} 93.39%)`,
    [breakpoints.up('md')]: {
      maxWidth: 1344,
      margin: '0 auto',
    },
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px 10px 20px',
    backgroundImage: `url(${benefitsBg})`,
    backgroundSize: 'auto 270px',
    backgroundRepeat: 'no-repeat',
    backgroundPositionY: '100%',
    [breakpoints.up('md')]: {
      padding: '36px 7% 30px',
      backgroundPositionX: '-5%',
      backgroundSize: 'auto 430px',
    },
  },
  title: {
    marginTop: 0,
    marginBottom: 32,
    color: palette.common.white,
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.lg,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      marginBottom: 48,
      fontSize: 36,
    },
    [breakpoints.up('xl')]: {
      transform: 'translateX(35%)',
    },
  },
  list: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    alignSelf: 'flex-end',
    gap: '0.75rem',
    padding: 0,
    margin: 0,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      maxWidth: '70%',
      gap: 20,
    },
    [breakpoints.up('xl')]: {
      gap: 80,
    },
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    height: 48,
    width: 170,
    padding: '0.5rem 0.375rem',
    border: `1px solid ${palette.common.white}`,
    borderRadius: 12,
    background: `linear-gradient(180deg, ${palette.common.white} 0%, #b6eafe 100%)`,
    color: palette.primary.contrastText,
    fontSize: fontSizes['3xs'],
    lineHeight: 1.3,
    [breakpoints.up('md')]: {
      height: 116,
      width: 364,
      gap: 24,
      padding: '18px 25px',
      borderRadius: 30,
      fontSize: fontSizes.lg,
    },
    '&:nth-of-type(2)': {
      paddingRight: 30,
      [breakpoints.up('md')]: {
        paddingRight: 40,
      },
    },
  },
}));
